import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-4 mr-4" }
const _hoisted_2 = { class: "flex flex-row space-x-4 items-end" }

import AvatarWithColor from "@/components/Friends/AvatarWithColor.vue";
import TextMedium from "@/components/Texts/TextMedium.vue";
import { useUsersStore } from "@/store/useUsersStore";
import { watch } from "vue";
import ThreeDotsIcon from "@/components/Icons/ThreeDotsIcon.vue";
import InputCheckbox from "@/components/Form/InputCheckbox.vue";
import { computed, ComputedRef, ref } from "vue";
import { useAuthStore } from "@/store/useAuthStore";
import { FriendInfos } from "@/interfaces/FriendInfos";
import ButtonSecondary from "@/components/Buttons/ButtonSecondary.vue";
import InputColor from "@/components/Form/InputColor.vue";
import { useFriendsStore } from "@/store/useFriendsStore";
import { useDialogsStore } from "@/store/useDialogsStore";
import BottomSheet from "@/components/Menus/BottomSheet.vue";
import TitleMedium from "@/components/Titles/TitleMedium.vue";
import ButtonPrimary from "@/components/Buttons/ButtonPrimary.vue";
import { FriendRequest } from "@/interfaces/FriendRequest";
import CrossIcon from "@/components/Icons/CrossIcon.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'FriendRequestManageView',
  props: {
    friendsRequest: {}
  },
  setup(__props: any) {

const authStore = useAuthStore();
const friendsStore = useFriendsStore();

const props = __props;

const { getUserById } = useUsersStore();
const user = computed(() => {
  return getUserById(props.friendsRequest.to);
});

const color: ComputedRef<string> = computed(() => {
  return user.value ? user.value.color : "#ffffff";
});

const deleteFriendRequest = () => {
  friendsStore.deleteFriendRequest(authStore.currentUser?.id, user.value?.id);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AvatarWithColor, {
        color: color.value,
        class: "flex-none h-12 mb-1"
      }, null, 8, ["color"]),
      _createVNode(TextMedium, {
        class: "flex-grow ml-2 md:ml-0",
        text: user.value.name
      }, null, 8, ["text"]),
      _createVNode(CrossIcon, {
        class: "text-white h-6",
        onClick: deleteFriendRequest
      })
    ])
  ]))
}
}

})